/**
 * Shared API configuration.
 * Single source of truth for backend base URL and health check.
 */

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
/** Set REACT_APP_VERSION in frontend/.env — shown at the bottom of the dashboard sidebar. */
export const APP_VERSION = (process.env.REACT_APP_VERSION || '').trim();

/**
 * Health check URL.
 *
 * Note: The backend exposes /api/health at the ROOT (no URL_SLUG),
 * so we must always hit {origin}/api/health, regardless of slugged API_BASE_URL.
 */
export function getHealthUrl() {
  // Backend exposes health at:
  // - /api/health (no slug)
  // - /{URL_SLUG}/api/health (slugged)
  // Derive the health URL from API_BASE_URL so prod/dev stay consistent.
  try {
    if (!API_BASE_URL) return 'http://localhost:3010/api/health';
    const base = String(API_BASE_URL).replace(/\/+$/, '');
    return `${base}/health`;
  } catch {
    return 'http://localhost:3010/api/health';
  }
}
